import { ICalendarDateActive } from 'src/app/interfaces/calendar';
import { Component, Input, OnInit, Output, EventEmitter } from '@angular/core';
import moment from 'moment';
import { ModalDismissReasons, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { RnumbService } from 'src/app/services/rnumb.service';
import { MatDialog } from '@angular/material/dialog';

import { getNameDay, strToDate } from '../../application/global.function';
import { ITalonModal } from 'src/app/interfaces/record.interface';
import { Router } from '@angular/router';
import { IRnumbList } from 'src/app/interfaces/rnumb.interface';

import { NewTalonComponentMobile } from 'src/app/modals/new-talon-mobile/talon.component';

import { lastValueFrom } from 'rxjs';
import { DoctorService } from 'src/app/services/doctor.service';

@Component({
    selector: 'app-list-upcoming',
    templateUrl: './list-upcoming.component.html',
    styleUrls: ['./list-upcoming.component.scss'],
})
export class ListUpcomingComponent implements OnInit {
    @Input() rNumbs: IRnumbList[] = [];

    @Output() onDateGet = new EventEmitter<ICalendarDateActive[]>();
    @Input()
    set selectDate(value: string) {
        this._selectDate = value;
        this.setFilterDate(this._selectDate);
    }

    _selectDate: string = ''; // выбранная дата
    _rNumbList: IRnumbList[] = [];
    rNumbList: IRnumbList[] = [];
    @Input()
    set selectedDate(value: string) {
        this._selectedDate = value;
        this.setFilterDate(this._selectedDate);
        this.selectedDateInCalenadr = moment(value).format('DD MMMM');
    }
    get selectedDate() {
        return this._selectedDate;
    }
    _selectedDate: string = ''; // выбранная дата

    loadingRnumbList = false; // Загрузка талонов
    selectedDateInCalenadr: string = '';
    isLoading = false;
    loadedPages = 1;
    viewPage = 1;
    countOfPages = 1;
    rnumbPages: IRnumbList[][] = [];
    rnumbListLength: number = 0; // Количество записей
    loadingMoreContent = false;
    isMobile: boolean = false;
    rnumbList: IRnumbList[] = [];
    filteredRnumbList: IRnumbList[] = [];
    closeResult: string = '';
    modalReference!: NgbModalRef;
    uploadFilesGroup: IRnumbList[] = [];
    mandatoryGroup: IRnumbList[] = [];
    othersGroup: IRnumbList[] = [];

    private handleResize = () => {
        this.isMobile = window.innerWidth <= 767;
    };

    constructor(
        private rs: RnumbService,
        private dialog: MatDialog,
        private router: Router,
        private doctorInfoService: DoctorService,
    ) {}

    ngOnInit(): void {
        this.isLoading = true;
        this.loadingRnumbList = true;
        this.getRnumbList().then(() => {
            this.isLoading = false;
        });
        this.isMobile = window.innerWidth <= 767;
        window.addEventListener('resize', this.handleResize);
    }

    ngOnDestroy(): void {
        window.removeEventListener('resize', this.handleResize);
    }

    //бут модалка для теле мои посещения
    open(e: Event, content: any) {
        e.stopPropagation();

        const dialogRef = this.dialog.open(content, {
            width: this.isMobile ? '90%' : '',
            // data: {},
        });

        dialogRef.afterClosed().subscribe((result) => {
            if (result) {
                this.closeResult = `Closed with: ${result}`;
            }
        });
    }

    getDismissReason(reason: any): string {
        if (reason === ModalDismissReasons.ESC) {
            return 'by pressing ESC';
        } else if (reason === ModalDismissReasons.BACKDROP_CLICK) {
            return 'by clicking on a backdrop';
        } else {
            return `with: ${reason}`;
        }
    }

    JoinAndClose() {
        // this.modalReference.close();
        this.dialog.closeAll();
    }

    async getRnumbList() {
        let dt: ICalendarDateActive[] = [];
        this.rnumbList = [];
        this.filteredRnumbList = [];
        this.loadingRnumbList = true;

        try {
            const res = await lastValueFrom(this.rs.getRnumbList());
            this.rnumbList = res;

            const selectedAppointmentId = sessionStorage.getItem(
                'selectedAppointmentId',
            );
            if (selectedAppointmentId) {
                const appointment = this.rnumbList.find(
                    (r) => r.rnumb_id === parseInt(selectedAppointmentId),
                );
                if (appointment) {
                    setTimeout(() => {
                        this.openTalon(appointment);
                        sessionStorage.removeItem('selectedAppointmentId');
                    }, 500);
                } else {
                    sessionStorage.removeItem('selectedAppointmentId');
                }
            }

            // Форматируем даты
            this.rnumbList.forEach((item) => {
                item.beginDate = strToDate(item.dat_bgn);
                item.endDate = strToDate(item.dat_end);
                dt.push({
                    date: Number(moment(item.beginDate).format('YYYYMMDD')),
                });
            });

            // Сортировка по времени (от ближайших к далёким)
            this.rnumbList.sort((a, b) => {
                return (
                    (a.beginDate?.getTime() || 0) -
                    (b.beginDate?.getTime() || 0)
                );
            });

            // Группируем по логике:
            // - uploadFilesGroup: нужно прикрепить файлы (is_upload_files=1, is_file_attached != 1)
            // - othersGroup: всё остальное (включая is_file_attached=1, form_result_id, и просто обычные)
            //  item.form_result_id && item.is_exists === 0;

            this.uploadFilesGroup = [];
            this.othersGroup = [];

            this.rnumbList.forEach((item) => {
                // Если нужно прикрепить файлы И файлы НЕ прикреплены
                if (
                    (item.is_upload_files === 1 &&
                        (!item.is_file_attached ||
                            item.is_file_attached !== 1)) ||
                    (item.form_result_id && item.is_exists === 0)
                ) {
                    this.uploadFilesGroup.push(item);
                } else {
                    this.othersGroup.push(item);
                }
            });

            // Объединяем, сохраняя порядок
            this.filteredRnumbList = [
                ...this.uploadFilesGroup,
                ...this.othersGroup,
            ];

            this.rnumbPages = [this.filteredRnumbList];
            this.onDateGet.emit(dt);
        } catch (error) {
            console.error('Ошибка загрузки талонов', error);
            dt.push({ date: Number(moment().format('YYYYMMDD')) });
            this.onDateGet.emit(dt);
        } finally {
            this.loadingRnumbList = false;

            const firstPage = this.rnumbPages[0];
            if (Array.isArray(firstPage) && firstPage.length === 0) {
                this.rnumbPages = [];
                this.countOfPages = 0;
            }
        }
    }
    private _groupedItems: { title: string; items: IRnumbList[] }[] = [];

    get groupedItems(): { title: string; items: IRnumbList[] }[] {
        const result: { title: string; items: IRnumbList[] }[] = [];

        const hasUploadGroup = this.uploadFilesGroup.length > 0;
        const hasOthersGroup = this.othersGroup.length > 0;

        if (hasUploadGroup) {
            result.push({
                title: 'Дополните посещения',
                items: this.uploadFilesGroup,
            });
        }

        if (hasOthersGroup) {
            result.push({
                title: hasUploadGroup ? 'Все посещения' : '',
                items: this.othersGroup,
            });
        }

        if (JSON.stringify(result) !== JSON.stringify(this._groupedItems)) {
            this._groupedItems = result;
        }

        return this._groupedItems;
    }

    getGroupTitle() {
        if (this.uploadFilesGroup.length > 0) {
            return 'Прикрепите файлы';
        }

        if (this.mandatoryGroup.length > 0) {
            return 'Заполните анкету';
        } else {
            return;
        }
    }
    getPriority(item: IRnumbList): number {
        if (this.isMobile && item.is_upload_files === 1) {
            return 0;
        } else if (item.form_result_id) {
            return 1;
        } else {
            return 2; // Default for others
        }
    }

    setActionsTitle(item: IRnumbList): string {
        if (!this.isMobile) return '';
        if (this.isMobile && item.is_upload_files === 1) {
            return 'Прикрепите файлы';
        } else if (item.form_result_id) {
            return 'Заполните анкету';
        } else {
            return 'За все время';
        }
    }

    getTime(dt: Date | undefined): string {
        if (dt && moment(dt).hour() > 3) {
            return moment(dt).format('HH:mm');
        } else {
            return '';
        }
    }

    getDate(dt: Date | undefined): string {
        if (dt) {
            return moment(dt).format('D MMMM YYYY');
        } else {
            return '';
        }
    }

    getTekDay(dt: Date | undefined): string {
        if (dt) {
            return moment(dt).format('D MMMM YYYY');
        } else {
            return '';
        }
    }

    getNameDay(dt: Date | undefined): string {
        if (dt) {
            let day = '';
            let d = 0;
            moment.locale('ru');
            d = moment().startOf('day').diff(moment(dt).startOf('day'), 'days');
            switch (d) {
                case 0: {
                    day = 'Сегодня';
                    break;
                }
                case 1: {
                    day = 'Завтра';
                    break;
                }
                default: {
                    day = getNameDay(dt);
                    break;
                }
            }
            return day;
        } else {
            return '';
        }
    }

    setFilterDate(dt: string) {
        if (dt.length == 0) {
            this.filteredRnumbList = this.rnumbList;
        } else {
            this.filteredRnumbList = this.rnumbList.filter(
                (item) => moment(item.beginDate).format('YYYY-MM-DD') === dt,
            );
        }
    }

    returnAllEvents() {
        this.getRnumbList();
    }

    openTalon(talon: IRnumbList, files?: FileList) {
        let dt: ITalonModal = {
            rnumbID: talon.rnumb_id,
            paramCansel: true,
            withUpload: Boolean(Number(talon.is_upload_files)),
            tag: talon.tag,
            link_id: talon.link_id,
            srv_text: talon.srv_text!,
            srv_description: talon.srv_description!,
            visit_id: talon.visit_id || undefined,
            is_exist: talon.is_exists || undefined,
            form_result_id: talon.form_result_id || undefined,
            // infoDoc: result.zone_symbol_value,
        };
        const result = lastValueFrom(
            this.doctorInfoService.getDocAboutInfo(talon.doctor_id),
        );

        result.then((res) => {
            dt.infoDoc = res;
        });

        if (files) dt.files = files;

        let dialogRefOptions = {
            width: 'auto',
            height: 'auto',
            maxWidth: 'auto',
            minWidth: 'auto',
            closeOnNavigation: true,
            data: dt,
        };

        // Check screen width and adjust dialog options if needed
        if (window.matchMedia('(max-width: 768px)').matches) {
            dialogRefOptions.width = '92vw';
            // dialogRefOptions.height = 'calc(100% - 2vh)';
            dialogRefOptions.maxWidth = '100vw';
            dialogRefOptions.minWidth = '90vw';
        }

        const dialogRef = this.dialog.open(
            NewTalonComponentMobile,
            dialogRefOptions,
        );

        dialogRef.afterClosed().subscribe((result) => {
            // Отмена номерка
            if (result && result.rnumbID && result.canselRes) {
                this.getRnumbList(); // Обновляем все
            }
        });
    }

    stopPropagation(e: Event) {
        e.stopPropagation();
    }

    // открыть в новом окне ТЕЛЕМЕДИЦИНУ
    goToTelemed(rec: IRnumbList, e: MouseEvent) {
        e.stopPropagation();

        if (rec.url_telemed && rec.url_telemed.length > 5) {
            window.open(rec.url_telemed, '_blank');
        }
        // else {
        //     this.openTalon(rec);
        // }
    }

    onVisitProtocolClick(talon: IRnumbList, e: MouseEvent) {
        e.stopPropagation();

        this.router.navigate([
            `home/visit-protocol/${talon.visit_id}/${talon.form_result_id}`,
        ]);
    }

    onChangeInputUpload(event: Event, talon: IRnumbList) {
        const target = event.target as HTMLInputElement;
        const files = target.files;
        // console.log(target, files);
        if (!files) {
            console.log('NO FILES IN INPUT');
            return;
        }
        // console.log(files);
        this.openTalon(talon, files);
        target.value = '';
        // console.log(this.fileInput);
    }
}
